import classNames from 'classnames/bind';
import commaNumber from 'comma-number';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import styles from './Monitor.module.scss';

import { Cell } from '@/components/ui/dashboard/Monitor';

const cx = classNames.bind(styles);

const Monitor = ({ robotId }) => {
  const robotStatus = useSelector((state) => state.robotStatus[robotId]);

  const { lat, lng, alt } = useMemo(() => {
    return {
      lat: robotStatus?.lat ?? 0,
      lng: robotStatus?.lon ?? 0,
      alt: robotStatus?.alt ?? 0,
    };
  }, [robotStatus]);

  return (
    <div className={cx('container')}>
      <div className={cx('boxes')}>
        <Cell data={[{ title: 'Latitude', value: lat.toFixed(6) }]} />
        <Cell data={[{ title: 'Longitude', value: lng.toFixed(6) }]} />
        <Cell data={[{ title: 'Altitude', value: commaNumber(alt.toFixed(1)), unit: 'm' }]} />
      </div>
    </div>
  );
};

export default Monitor;
